import { useRootSelector } from "screens/Root/hooks/useAppSelector";
export const useIsPatientSpecific = (menuId) => {
    const { appSettings: { StaticData }, } = useRootSelector();
    return (menuId &&
        StaticData &&
        StaticData.MenuItems[menuId] &&
        StaticData.MenuItems[menuId].IsPatientSpecific);
};
